import React, { Component } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { configuration } from "../../appConfig";
import axios from "axios";
import Select from "react-select";
import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export class ReportAuthorizationHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isOpenDentsCountModal: false,
      isOpenWithoutEmailAuthorizationModal: false,
      isOpenWithEmailAuthorizationModal: false,
      totalDentCount: 0,
      error: [],

      // With email authorizer modal
      authorizerName: "",
      sendEmail: "",
      subject: "",
      ccEmailArr: [],
      ccAccountsArr: [],
      optionArr: [],
      ccEmailOptionArr: [],
      ccAccountOptionArr: [],
      emailArr: [],
      isWithEmailModal: false,
      isAuthorizeLoader: false,
      ReportGenerated: false,
    };
  }

  componentDidMount = () => {
    this.getInsuranceClientsEmails();
    this.getFallbackDetails();
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.jsonData.ReportGenerated !== prevState.ReportGenerated) {
      return { ReportGenerated: nextProps.jsonData.ReportGenerated };
    } else if (nextProps.jsonData.TotalDentCount !== prevState.totalDentCount && nextProps.jsonData.TotalDentCount) {
      return { totalDentCount: nextProps.jsonData.TotalDentCount };
    } else if (!prevState.authorizerName && nextProps.jsonData.AuthorizedName) {
      return { authorizerName: nextProps.jsonData.AuthorizedName };
    } else {
      return null;
    }
  }

  /* mapping data to options */
  mapDataToOptions = (data, key) => {
    return (
      (data &&
        data[key] &&
        data[key].map((item) => ({ value: item, label: item }))) ||
      []
    );
  };

  /* Get emails of the all insurance clients */
  getInsuranceClientsEmails = () => {
    const partnerId = localStorage.getItem("partnerId");
    const url = configuration.getInsuranceEmails + "?partnerId=" + partnerId;
    axios.get(url).then((res) => {
      if (res.data.data) {
        const { data } = res.data;
        let defaultName =
                    data && data.Emails && data.Emails.DefaultAuthorizerName
                        ? data.Emails.DefaultAuthorizerName
                        : "";
                let sendEmailDefault =
                data && data.Emails && data.Emails.SendEmailByDefault == "no" ? false : true;

                let emailResponse = this.mapDataToOptions(data && data.Emails, "to") || [];
                let emailResponseDefault =
                    this.mapDataToOptions(data && data.Emails, "toEmailDefault") || [];
                let emailResponseCC = this.mapDataToOptions(data && data.Emails, "cc") || [];
                let emailResponseDefaultCC =
                    this.mapDataToOptions(data && data.Emails, "CCEmailDefault") || [];

                let accounts = this.mapDataToOptions(data && data.ccAccount, "CCaccount") || [];
                let accounts_default =
                    this.mapDataToOptions(data && data.ccAccount, "CCaccountDefault") || [];

        const { optionArr, ccEmailOptionArr } = this.state;
        this.setState({
          // selectedOption : [...emailresponce],
          authorizerName: this.state.authorizerName ? this.state.authorizerName : (defaultName[0] || ''),
          sendEmail: sendEmailDefault,
          emailArr: [...emailResponseDefault],
          ccEmailArr: [...emailResponseDefaultCC],
          ccAccountsArr: [...accounts_default],
          optionArr: [...optionArr, ...emailResponse],
          ccEmailOptionArr: [...ccEmailOptionArr, ...emailResponseCC],
          ccAccountOptionArr: [...this.state.ccAccountOptionArr, ...accounts],
        });
      }
    });
  };

  /* Get Fallback details */
  getFallbackDetails = () => {
    const url =
      configuration.getFallbackDetails +
      `?partner_id=${localStorage.getItem("partnerId")}`;
    axios
      .get(url)
      .then((res) => {
        if (res && res.data) {
          this.setState({
            isWithEmailModal: res.data.is_email == "1",
          });
        } else {
          Toast.fire({
            type: "error",
            title: "Something went wrong! Please try again later.",
          });
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something went wrong! Please try again later.",
        });
      });
  };

  toggleModal = (modalName) => {
    this.setState({
      [modalName]: !this.state[modalName],
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: name === "authorizerName" ? value.trimStart() : value,
    });
  };

  toggleSendEmail = (e) => {
    this.setState({
      sendEmail: e.target.checked,
    });
  };

  handleSelectChange = (value, name) => {
    this.setState({
      [name]: value,
    });
  };

  handleSave = () => {
    const { authorizerName, isWithEmailModal } = this.state;
    const error = [];

    if (!authorizerName.trim()) {
      error.push("#emptyAuthorizerName");
    }

    if (error.length) {
      this.setState({
        error,
      });
    } else {
      this.setState({
        error: [],
      });
      this.setState({
        isAuthorizeLoader: true,
      });
      const partnerId = localStorage.getItem("partnerId");
      const vin = localStorage.getItem("selectedFile");
      const url =
        configuration.storeAuthorizedName +
        `?partnerId=${partnerId}&vin=${vin}&name=${authorizerName}`;
      axios.post(url).then((res) => {
        if (res.data.status === 200) {
          if (!error.length) {
            window.history.pushState(null, "", window.location.href);
            window.onpopstate = function () {
              window.history.pushState(null, "", window.location.href);
            };
            this.updateJSON();
          }
        } else {
          Toast.fire({
            type: "error",
            title: "Something went wrong! Please try again later.",
          });
          this.setState({
            isAuthorizeLoader: false
          }, () => this.toggleModal(
            isWithEmailModal
              ? "isOpenWithEmailAuthorizationModal"
              : "isOpenWithoutEmailAuthorizationModal"
          ))
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something went wrong! Please try again later.",
        });
        this.setState({
          isAuthorizeLoader: false
        }, () => this.toggleModal(
          isWithEmailModal
            ? "isOpenWithEmailAuthorizationModal"
            : "isOpenWithoutEmailAuthorizationModal"
        ))
      })
    }
  };

  updateJSON = () => {
    const [partnerId, vin] = [
      localStorage.getItem("partnerId"),
      localStorage.getItem("selectedFile"),
    ];
    const { authorizerName, isWithEmailModal, driveType } = this.state;
    const { jsonData } = this.props;
    const PostEditorURL = `${configuration.PostEditorChanges}?partnerId=${partnerId}&vin=${vin}`;

    const updatedJSON = {
      ...jsonData,
      Authorized: false,
      ReportGenerated: false,
      AuthorizedName: authorizerName,
      ReportGeneratedStatus: "PENDING",
      DriveThrough: (driveType === "drive_in") ? "1" : ((driveType === "drive_through") && "0")
    };

    axios
      .post(PostEditorURL, updatedJSON)
      .then((res) => {
        if (res.data.success) {
          if (isWithEmailModal) {
            this.authorizePDFWithEmail();
          } else {
            this.authorizePDFWithoutEmail();
          }
        } else {
          Toast.fire({
            type: "error",
            title: "Something went wrong! Please try again later.",
          });
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something went wrong! Please try again later.",
        });
      });
  };

  createDuplicateVIN = () => {
    const { ccAccountsArr } = this.state;
    const [partnerId, vin] = [localStorage.getItem('partnerId'), localStorage.getItem('selectedFile')];
    if(ccAccountsArr.length) {
      const ccAccountsValueArr = ccAccountsArr.map((el) => el.value);
      const url = configuration.createDuplicateVin;
      const payload = {
        vin,
        main_partnerId : partnerId,
        cc_partnerId : ccAccountsValueArr
      };

      axios.post(url,payload)
        .then((res) => {
          if(!res.data.success) {
            Toast.fire({
              type: "error",
              title: "Something went wrong in the create duplicate VIN in the CC account",
            });
          }
        })
        .catch((err) => {
          Toast.fire({
            type: "error",
            title: "Something went wrong in the create duplicate VIN in the CC account",
          });
        });

    }

  }

  authorizePDFWithEmail = () => {
    const [partnerId, vin] = [
      localStorage.getItem("partnerId"),
      localStorage.getItem("selectedFile"),
    ];
    const { subject, authorizerName, emailArr, ccEmailArr, sendEmail, isWithEmailModal, driveType } = this.state;
    const { reportType, changeAuthorizeFlag, lang } = this.props;

    const url = configuration.automated_scripts;

    const emailValueArr = emailArr.map((el) => el.value);
    const ccEmailValueArr = ccEmailArr.map((el) => el.value);
    const SendEmail = sendEmail === true ? "yes" : "no"

    const payload = {
      partnerId,
      vin,
      authorizer_name: authorizerName,
      subject,
      AuthrizeEmail: emailValueArr,
      report: reportType,
      cc: ccEmailValueArr,
    };

    if(driveType === 'drive_through') {
      /* Add SendEmail key value when authorize type is drive through */
      payload.SendEmail = SendEmail;
    } else if(driveType === 'drive_in') {
      /* Add SendEmail key value when authorize type is drive in */
      payload.send_email_mini = "yes";
    }

    axios
      .post(url, payload)
      .then((res) => {
        if (res.status === 200) {
          this.createDuplicateVIN();
          this.setState(
            {
              isOpenWithEmailAuthorizationModal: false,
              ReportGenerated: false,
              isAuthorizeLoader: false,
              sendEmail: isWithEmailModal ? true : false, 
            },
            () => changeAuthorizeFlag(true, driveType),
          );
          Toast.fire({
            type: "success",
            title: lang(
              "All reports are being generated. Please check All Scan Records page after sometime.",
            ),
          });
        } else if (res.data.status === 500) {
          this.setState({
            isOpenWithEmailAuthorizationModal: false,
          });
          // vin or partner Id missing
          Toast.fire({
            type: "error",
            title: "Something went wrong! Please try again later.",
          });
        } else {
          this.setState({
            isOpenWithEmailAuthorizationModal: false,
          });
          Toast.fire({
            type: "error",
            title: "pdf generate failed",
          });
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something went wrong! Please try again later.",
        });
      })
      .finally(() => {
        this.setState({
          isAuthorizeLoader: false,
        });
      });
  };

  authorizePDFWithoutEmail = () => {
    const [partnerId, vin] = [
      localStorage.getItem("partnerId"),
      localStorage.getItem("selectedFile"),
    ];
    const { changeAuthorizeFlag, lang, isRemoveDriveThroughButton } = this.props;

    const url = configuration.generatePDF;
    axios
      .post(url, {
        partnerId,
        vin,
      })
      .then((res) => {
        if (res.status === 200) {
          this.setState(
            {
              isOpenWithoutEmailAuthorizationModal: false,
              ReportGenerated: false,
            },
            () => changeAuthorizeFlag(true),
          );
          Toast.fire({
            type: "success",
            title: lang(
              "All reports are being generated. Please check All Scan Records page after sometime.",
            ),
          });
        } else if (res.data.status === 500) {
          this.setState({
            isOpenWithoutEmailAuthorizationModal: false,
          });
          // vin or partner Id missing
          Toast.fire({
            type: "error",
            title: "Something went wrong! Please try again later.",
          });
        } else {
          this.setState({
            isOpenWithoutEmailAuthorizationModal: false,
          });
          Toast.fire({
            type: "error",
            title: "pdf generate failed",
          });
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "pdf generate failed",
        });
      })
      .finally(() => {
        this.setState({
          isAuthorizeLoader: false,
        });
      });
  };

  deAuthorizePDF = () => {
    const [partnerId, vin] = [
      localStorage.getItem("partnerId"),
      localStorage.getItem("selectedFile"),
    ];
    const { authorizerName } = this.state;
    const { jsonData, changeAuthorizeFlag } = this.props;

    const url =
      configuration.PostEditorChanges + `?partnerId=${partnerId}&vin=${vin}`;

    this.setState({
      deAuthorizeLoading: true,
    });

    // this.state.fullData.Authorized = false
    let payload = {
      ...jsonData,
      Authorized: false,
      DATReportAuthorized: false,
      ReportGenerated: false,
      AuthorizedName: authorizerName,
      ReportGeneratedStatus: "PENDING",
    };
    axios
      .post(url, payload)
      .then((res) => {
        Toast.fire({
          type: "success",
          title: "De-Authorize PDF successfully!",
        });
        this.setState(
          {
            deAuthorizeLoading: false,
            ReportGeneratedStatus: "PENDING",
          },
          () => changeAuthorizeFlag(false),
        );
      })
      .catch((err) => {
        this.setState({
          deAuthorizeLoading: false,
        });
      });
  };

  downloadReportZip = () => {
    
    const { selectedLanguage } = this.props;

    this.setState({
      isDownloading: true
    });
    
    const [partnerId, vin] = [localStorage.getItem('partnerId'), localStorage.getItem('selectedFile')];
    const url = `${configuration.downloadReports}?partnerId=${partnerId}&vin=${vin}&lang=${selectedLanguage}`
    
    axios.get(url)
      .then((res) => {
        if (res.data.status === 200) {
          this.downloadFile(res.data.data, `${vin}.zip`)
            .then(() => {
              this.setState({
                isDownloading: false,
                downloadProgress: 0
              })
              Toast.fire({
                type: "success",
                title: "Zip download successfully!",
              });
            }).catch((err) => {
              this.setState({
                downloading: false,
                downloadProgress: 0
              })
              Toast.fire({
                type: "error",
                title: "Something want wrong!",
              });
            })
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something want wrong!",
        });
      })
  }

  downloadFile = async (file, fileName) => {
    return new Promise((resolve, reject) => {
      if (file) {
        const options = {
          onDownloadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            this.setState({
              downloadProgress: Math.floor((loaded * 100) / total),
            });
          },
        };

        axios.get(file, {
          responseType: "blob",
          ...options,
        }).then(function (response) {

          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        })
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          })
      } else {
        reject();
      }
    })
  }

  render() {
    const {
      isOpenDentsCountModal,
      isOpenWithoutEmailAuthorizationModal,
      isOpenWithEmailAuthorizationModal,
      totalDentCount,
      error,
      optionArr,
      ccEmailOptionArr,
      ccEmailArr,
      authorizerName,
      subject,
      isWithEmailModal,
      emailArr,
      isAuthorizeLoader,
      deAuthorizeLoading,
      isDownloading,
      ReportGenerated,
      sendEmail,
      ccAccountsArr,
      ccAccountOptionArr,
      driveType
    } = this.state;
    const { lang, isAuthorized, isRemoveDriveThroughButton, jsonData: { DriveThrough = ''} } = this.props;
    return (
      <>
        {/* Authorize Drive-in */}
        <button
          className={`glass btn btn-lg ${(isAuthorized && DriveThrough === '1') ? "btn-success" : "btn-danger"} mr-1`}
          id="authorize"
          onClick={() => {
            this.setState({
              driveType : "drive_in"
            });
            (!totalDentCount || !parseInt(totalDentCount))
              ? this.toggleModal("isOpenDentsCountModal")
              : this.toggleModal(
                  isWithEmailModal
                    ? "isOpenWithEmailAuthorizationModal"
                    : "isOpenWithoutEmailAuthorizationModal"
                );
          }}
          disabled={isAuthorizeLoader || isAuthorized}
        >
          {isAuthorizeLoader ? (
            <div
              className="spinner-border"
              role="status"
              style={{ width: "1.5rem", height: "1.5rem" }}
            >
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <i className="fa fa-print" />
          )}
          &nbsp; {lang("Authorize PDF Drive-In")}
        </button>

        {/* Authorize Drive-throgh */}
        {!isRemoveDriveThroughButton && 
          <button
            className={`glass btn btn-lg ${(isAuthorized && DriveThrough === '0') ? "btn-success" : "btn-danger"} mr-1`}
            id="drive_through_authorize"
            onClick={() => {
              this.setState({
                driveType : "drive_through"
              });
              (!totalDentCount || !parseInt(totalDentCount))
                ? this.toggleModal("isOpenDentsCountModal")
                : this.toggleModal(
                    isWithEmailModal
                      ? "isOpenWithEmailAuthorizationModal"
                      : "isOpenWithoutEmailAuthorizationModal"
                  );
            }}
            disabled={isAuthorizeLoader || isAuthorized}
          >
            {isAuthorizeLoader ? (
              <div
                className="spinner-border"
                role="status"
                style={{ width: "1.5rem", height: "1.5rem" }}
              >
                <span className="sr-only">Loading...</span>
              </div>
            ) : (
              <i className="fa fa-print" />
            )}
            &nbsp; {lang("Authorize PDF Drive-Through")}
          </button>
        }

        {/* De-Authorize PDF */}
        <button
          className={`glass btn btn-danger btn-lg mr-1`}
          id="authorize"
          onClick={() => this.deAuthorizePDF()}
          disabled={!isAuthorized || deAuthorizeLoading}
        >
          {deAuthorizeLoading ? (
            <div
              className="spinner-border"
              role="status"
              style={{ width: "1.5rem", height: "1.5rem" }}
            >
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <i className="fa fa-print" />
          )}
          &nbsp; {lang("De-Authorize PDF")}
        </button>

        {/* Download Report */}
        {(isAuthorized && ReportGenerated == true && !isRemoveDriveThroughButton) &&
          <button
            className={`btn btn-lg  mr-1 btn-danger`}
            onClick={() => this.downloadReportZip()}
            // disabled={ this.state.ReportGenerated ? (!this.state.Authorized || this.state.Authorized) : (!this.state.Authorized || this.state.Authorized) && this.state.DATReportAuthorized}
            disabled={(!this.state.Authorized && (this.state.ReportGenerated === undefined)) || (this.state.Authorized && this.state.DATReportAuthorized  && 
              this.state.ReportGenerated)}
              // disabled={!this.state.Authorized || this.state.Authorized && this.state.DATReportAuthorized  && (this.state.ReportGenerated)}
          >
            {isDownloading  ? (
              <div
              className="spinner-border"
              role="status"
              style={{ width: "1.5rem", height: "1.5rem" }}
              >
                <span className="sr-only">Loading...</span>
              </div>
            ) : (
              <i className="fa fa-download" />
              )}
            &nbsp; {lang("Download report")}
          </button>
        }

        {/* Dent Count Modal */}
        <Modal
          size="md"
          isOpen={isOpenDentsCountModal}
          className="dent_zero_modal"
          backdrop="static"
          toggle={() => this.toggleModal("isOpenDentsCountModal")}
        >
          <ModalBody className="text-center">
            <p className="mb-3 text-message-extra-image">
              <b>
                {lang(
                  "The total number of dents is 0. Would you still like to authorize.",
                )}
              </b>
            </p>
            <Button
              className="btn btn-danger p-2 mr-2"
              onClick={() =>{
                const modalName = isWithEmailModal ? "isOpenWithEmailAuthorizationModal" : "isOpenWithoutEmailAuthorizationModal";
                this.setState({ 
                  isOpenDentsCountModal: false,
                  [modalName]: !this.state[modalName]
                });
              }
              }
            >
              {lang("Yes")}
            </Button>
            <Button
              className="btn btn-cancel p-2"
              onClick={() => this.toggleModal("isOpenDentsCountModal")}
            >
              {lang("No")}
            </Button>
          </ModalBody>
        </Modal>

        {/* Without Email Authorizer PDF Modal*/}
        <Modal
          isOpen={isOpenWithoutEmailAuthorizationModal}
          className="authorizer_name_modal"
          backdrop="static"
          toggle={() =>
            this.toggleModal("isOpenWithoutEmailAuthorizationModal")
          }
        >
          <ModalHeader className="align-item-center">
            {lang("Authorizer_name")}
          </ModalHeader>
          <ModalBody>
            <form>
              <div className="form_group">
                {/* {this.state.id === "drive_through" &&
                  <p>{lang("This is a test feature and not intended for general use. Proceed further only if you are authorized to do so.")}</p>} */}
                <input
                  className="form-control"
                  placeholder={lang("Authorizer Name")}
                  type="text"
                  name="authorizerName"
                  value={authorizerName}
                  onChange={(e) => this.handleChange(e)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      this.handleSave();
                    }
                  }}
                />
                {error.includes("#emptyAuthorizerName") && (
                  <span style={{ color: "red" }}>
                    {lang("Please enter your name")}
                  </span>
                )}
              </div>
            </form>
          </ModalBody>
          <ModalFooter>
            <div>
              <Button
                color="secondary"
                className="btn btn-md p-2 mr-2"
                onClick={() =>
                  this.toggleModal("isOpenWithoutEmailAuthorizationModal")
                }
              >
                {" "}
                {lang("Cancel")}{" "}
              </Button>
              <Button
                color="secondary"
                className="btn btn-md p-2 btn-danger"
                onClick={() => this.handleSave()}
              >
                {" "}
                {lang("Save")}{" "}
              </Button>
            </div>
          </ModalFooter>
        </Modal>

        {/* With Email Authorizer PDF Modal*/}
        <Modal
          size="lg"
          isOpen={isOpenWithEmailAuthorizationModal}
          className="authorizer_emailsend_modal"
          backdrop="static"
          toggle={() => this.toggleModal("isOpenWithEmailAuthorizationModal")}
        >
          <ModalBody>
            <form>
              <div className="form_group mb-2">
                <label className="mb-1">{lang("Authorizer Name")}</label>
                <input
                  className="form-control"
                  placeholder={lang("Authorizer Name")}
                  type="text"
                  name="authorizerName"
                  value={authorizerName}
                  onChange={(e) => this.handleChange(e)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      this.handleSave();
                    }
                  }}
                />
                {error.includes("#emptyAuthorizerName") && (
                  <span style={{ color: "red" }}>
                    {lang("Please enter your name")}
                  </span>
                )}
              </div>
              <div className="form_group mb-2">
                <label className="mb-1">{lang("Subject")}</label>
                <input
                  className="form-control"
                  type="text"
                  name="subject"
                  value={subject}
                  onChange={(e) => this.handleChange(e)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      this.handleSave();
                    }
                  }}
                />
              </div>
              <div className="form_group mb-2">
                <div className="d-flex justify-content-between mb-2 align-items-center">
                  <div>
                    <label className="mb-0">{lang("Email Address")}</label>
                  </div>
                  {/* <div className="main-wrapper-switch-lab-modal">
                    <div className="admin-list report_switch_wrapper">
                      <label className="name">{lang("Send Email")}</label>
                      <label className="switch">
                        <input
                          className="switch-input"
                          type="checkbox"
                          name="sendEmail"
                          id="sendEmail"
                          value={sendEmail}
                          onClick={(e) => this.toggleSendEmail(e)}
                          checked={sendEmail}
                        />
                        <span
                          className="switch-label"
                          data-on={lang("Yes")}
                          data-off={lang("No")}
                        ></span>
                        <span className="switch-handle"></span>
                      </label>
                    </div>
                  </div> */}
                </div>
                <Select
                  className="email_address_selection"
                  closeMenuOnSelect={false}
                  onChange={(value) =>
                    this.handleSelectChange(value, "emailArr")
                  }
                  defaultValue={emailArr}
                  isMulti
                  options={optionArr}
                />
                <div className="form_group mb-2 mt-2">
                  <label className="name mb-2">{lang("CC Email Address")}</label>
                  <Select
                    className="email_address_selection"
                    closeMenuOnSelect={false}
                    name="ccEmailArr"
                    onChange={(value) =>
                      this.handleSelectChange(value, "ccEmailArr")
                    }
                    defaultValue={ccEmailArr}
                    isMulti
                    options={ccEmailOptionArr}
                  />
                </div>
                <div className="form_group mb-2 mt-2">
                    <label className="name mb-2">{lang("CC Accounts")}</label>
                    <Select
                      className="email_address_selection"
                      closeMenuOnSelect={false}
                      onChange={(value) => this.handleSelectChange(value,'ccAccountsArr')}
                      defaultValue={ccAccountsArr}
                      isMulti
                      options={ccAccountOptionArr}
                    />
                  </div>
              </div>
            </form>
          </ModalBody>
          <ModalFooter>
            <div>
              <Button
                className="btn btn-cancel  p-2 mr-2"
                onClick={() =>
                  this.toggleModal("isOpenWithEmailAuthorizationModal")
                }
              >
                {" "}
                {lang("Cancel")}{" "}
              </Button>
              <Button
                className="btn p-2 btn-danger"
                onClick={() => {
                  this.handleSave();
                }}
              >
                {" "}
                {lang("Save")}{" "}
              </Button>
            </div>
          </ModalFooter>
        </Modal>

        {/* Authorize Loader */}
        <Modal
          centered
          size="lg"
          isOpen={isAuthorizeLoader}
          className="authorise_modalpopup"
          backdrop="static"
          toggle={() => this.setState({ isAuthorizeLoader: false })}
        >
          <ModalBody className="text-center">
            <p className="mb-3 text-message-extra-image">
              <b>
                {lang("Please wait Authorization in progress")}
                <span className="dot-flashing"></span>
              </b>
            </p>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default ReportAuthorizationHandler;
